import type { SocialPlatform } from "@ui/Molecules/Social/SocialChips";
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

/**
 * Maps a social permalink to its platform's oEmbed-style iframe URL, used as
 * a stand-in for a hosted video file (see backend-requirements.md CF-7/CF-9).
 * Returns null when the platform has no iframe embed or the URL doesn't
 * match the expected shape.
 */
export function socialEmbedUrl(
	platform: SocialPlatform,
	sourceUrl: string,
): string | null {
	if (platform === "instagram") {
		const match = sourceUrl.match(/instagram\.com\/(p|reel)\/([^/?]+)/);
		return match
			? `https://www.instagram.com/${match[1]}/${match[2]}/embed`
			: null;
	}

	if (platform === "tiktok") {
		const match = sourceUrl.match(/\/video\/(\d+)/);
		return match ? `https://www.tiktok.com/embed/v2/${match[1]}` : null;
	}

	if (platform === "youtube") {
		const match = sourceUrl.match(/(?:v=|youtu\.be\/|shorts\/)([\w-]{11})/);
		return match ? `https://www.youtube.com/embed/${match[1]}` : null;
	}

	return null;
}
